export const selectModalEnterTheme = {
  selectText: 'palette.tertiary.50',
};
